export default [
  {
    path: '/credentials',
    name: 'public.credentialCourses',
    components: {
      default: () => import(/* webpackChunkName: "credential" */ '@/modules/credentialCourse/views/catalogue/index.vue'),
      header: () => import(/* webpackChunkName: "credential" */ '@/views/public/header/index.vue'),
      footer: () => import(/* webpackChunkName: "credential" */ '@/views/public/footer/index.vue')
    }
  },
  {
    path: '/credential/:courseCode/:access',
    name: 'credential.course',
    props: {
      default: true
    },
    components: {
      default: () => import(/* webpackChunkName: "credential" */ `@/modules/credentialCourse/views/index.vue`)
    }
  },
  {
    path: '/credential/:courseCode/:access/thank-you',
    name: 'credential.course.thankyou',
    props: {
      default: true
    },
    beforeEnter(to, from, next) {
      if (['members', 'enrol'].indexOf(to.params.access) <= -1) {
        next(`/credential/${to.params.courseCode}/enrol`)
      }

      to.matched[0].components = {
        default: () => import(/* webpackChunkName: "credential" */ '@/modules/credentialCourse/views/Success.vue')
      }

      next()
    }
  }
]
